import Controller from "./controller";

let ChatBoxController = new Controller();

export {
    ChatBoxController
}
